import React from 'react';
import { NavLink } from 'react-router-dom';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { getRowUnits } from 'utils/util';
import { PRODUCT_CATEGORY_SET, PRODUCT_USE_TYPE_SET } from 'enums/product.enum';
import Loading from 'components/_common/Loading';

const ProductListV = ({
    params,
    setParams,
    setSearch,
    pageChanged,
    handleChange,
    onChangeRowUnit,
    onSearch,
    toggleActive
}) => (
    <>
        {params.isLoaded && params.error == null ? (
            <>
                <div className="content-header">
                    <h1>
                        <span>제품 관리</span>
                    </h1>
                </div>
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header p-0 mt_20">
                            <div className="card-header-left"></div>
                            <div className="card-header-right">
                                <NavLink to="add">
                                    <button className="btn btn-primary" type="button">
                                        등록
                                    </button>
                                </NavLink>
                            </div>
                        </div>
                        <div className="card-header p-0 mt_20">
                            <div className="row justify-content-between gap-3">
                                <div className="col-auto">
                                    <div className="g_table_sort">
                                        <span className="g_select">
                                            <select className="form-control" onChange={onChangeRowUnit} value={params.search.rows}>
                                                {getRowUnits().map((item, index) => (
                                                    <option key={index} value={item}>
                                                        {item}
                                                    </option>
                                                ))}
                                            </select>
                                        </span>
                                        / {params?.total?.toLocaleString()} rows
                                    </div>
                                </div>
                                <div className="col-auto list-filter">
                                    <div className="row gap-2">
                                        <div className="col-auto">
                                            <select
                                                className="form-control"
                                                onChange={(e) => {
                                                    handleChange(e, 'search.category', setParams, params);
                                                }}
                                                name="search.category"
                                                value={params.search.category || ''}
                                            >
                                                <option value="">카테고리</option>
                                                {PRODUCT_CATEGORY_SET.map((category, index) => (
                                                    <option key={`category${index}`} value={category}>
                                                        {category === 'BOILER' ? '보일러' :
                                                            category === 'PART' ? '부품' :
                                                                category === 'HEAVY_PART' ? '중부품' : category}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-auto">
                                            <select
                                                className="form-control"
                                                onChange={(e) => {
                                                    handleChange(e, 'search.useType', setParams, params);
                                                }}
                                                name="search.useType"
                                                value={params.search.useType || ''}
                                            >
                                                <option value="">용도</option>
                                                {PRODUCT_USE_TYPE_SET.map((useType, index) => (
                                                    <option key={`useType${index}`} value={useType}>
                                                        {useType === 'AS' ? 'A/S' :
                                                            useType === 'SALE' ? '판매' : useType}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-auto">
                                            <select
                                                className="form-control"
                                                onChange={(e) => {
                                                    handleChange(e, 'search.isActive', setParams, params);
                                                }}
                                                name="search.isActive"
                                                value={params.search.isActive === true ? 'true' :
                                                    params.search.isActive === false ? 'false' : ''}
                                            >
                                                <option value="">사용여부</option>
                                                <option value="true">활성</option>
                                                <option value="false">비활성</option>
                                            </select>
                                        </div>
                                        <div className="col-auto">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="제품코드/제품명 검색"
                                                    value={params.search.keyword || ''}
                                                    onChange={(e) => handleChange(e, 'search.keyword', setParams, params)}
                                                    onKeyDown={(e) => e.key === 'Enter' && onSearch()}
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-outline-secondary" type="button" onClick={onSearch}>
                                                        <i className="fas fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card-body table-responsive p-0">
                            <table className="table text-nowrap">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th className="tal">제품코드</th>
                                        <th className="tal">제품명</th>
                                        <th className="tal">카테고리</th>
                                        <th className="tal">용도</th>
                                        <th className="tar">판매가</th>
                                        <th className="tar">원가</th>
                                        <th className="tac">사용여부</th>
                                        {/* <th className="tac">액션</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {params.isLoaded && params.error == null && (
                                        <>
                                            {params.items.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{params.search.rows * params.search.page - (params.search.rows - (index + 1))}</td>
                                                    <td className="tal">
                                                        <NavLink to={'update/' + item.id}>{item.productCode}</NavLink>
                                                    </td>
                                                    <td className="tal">{item.productName}</td>
                                                    <td className="tal">
                                                        {item.category === 'BOILER' ? '보일러' :
                                                            item.category === 'PART' ? '부품' :
                                                                item.category === 'HEAVY_PART' ? '중부품' : item.category}
                                                    </td>
                                                    <td className="tal">
                                                        {item.useType === 'AS' ? 'A/S' :
                                                            item.useType === 'SALE' ? '판매' : item.useType}
                                                    </td>
                                                    <td className="tar">{item.price?.toLocaleString() || '0'}원</td>
                                                    <td className="tar">{item.costPrice?.toLocaleString() || '-'}원</td>
                                                    <td className="tac">
                                                        <span className={`badge ${item.isActive ? 'badge-success' : 'badge-secondary'}`}>
                                                            {item.isActive ? '활성' : '비활성'}
                                                        </span>
                                                    </td>
                                                    {/* <td className="tac">
                                                        <button
                                                            type="button"
                                                            className={`btn btn-sm ${item.isActive ? 'btn-warning' : 'btn-success'}`}
                                                            onClick={() => toggleActive(item.id)}
                                                        >
                                                            {item.isActive ? '비활성화' : '활성화'}
                                                        </button>
                                                    </td> */}
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <PaginationControl
                            page={params.search.page}
                            total={params.total}
                            limit={params.search.rows}
                            changePage={(page) => {
                                pageChanged(page, params.search, setParams, setSearch);
                                console.log(page);
                            }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </>
        ) : (
            <Loading />
        )}
    </>
);

export default ProductListV;